var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//-----------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect, useState } from "react";
// Material ui Imports
import { Box, Grid, LinearProgress, Slider } from "@mui/material";
import { CancelRounded, FastForwardRounded, FastRewindRounded, PauseRounded, PlayArrowRounded, SaveRounded, VolumeOffRounded, VolumeUpRounded, } from "@mui/icons-material";
// Customer components imports (and hooks and helpers)
import VTButton from "./VTButton";
import VTTextField from "./VTTextField";
import { getTimeElapsedInStopWatchFormatString } from "../helpers/GetTimeElapsedFormatted.helper";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTVideoControls To use the VTSphere
export default function VTVideoControls(_a) {
    var videoCurrentTime = _a.videoCurrentTime, videoCurrentState = _a.videoCurrentState, setVideoCurrentState = _a.setVideoCurrentState, video = _a.video, sx = _a.sx;
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##
    var _b = __read(useState(false), 2), currentTimeEditing = _b[0], setCurrentTimeEditing = _b[1];
    var _c = __read(useState(videoCurrentTime), 2), currentTimeEditInput = _c[0], setCurrentTimeEditInput = _c[1];
    var _d = __read(useState(false), 2), currentlyMuted = _d[0], setCurrentMuted = _d[1];
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    useEffect(function () {
        if (video.muted !== currentlyMuted) {
            setCurrentMuted(video.muted);
        }
    }, [video.muted]);
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    //-------------------------------------------------------------------------------------------------
    // ## CUSTOM FUNCTIONS ##
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    // Returns loading spinners || default cube || image cube
    return (_jsxs(Grid, __assign({ container: true, sx: __assign(__assign({}, sx), { position: "absolute", bottom: "12px", width: "100%", zIndex: 1000 }) }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, sx: {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "calc(100% - " + 100 + "px)",
                    paddingInline: "20px",
                } }, { children: [_jsx(Box, __assign({ component: "div", sx: {
                            position: "absolute",
                            top: 13,
                            left: "20px",
                            width: "calc(100% - " + 40 + "px)",
                        } }, { children: video.buffered.length >= 1 && (_jsx(LinearProgress, { sx: {
                                zIndex: 800,
                                borderRadius: "15px",
                                with: "100%",
                            }, color: "info", variant: "determinate", value: (video.buffered.end(video.buffered.length - 1) / video.duration) * 100 })) })), _jsx(Slider, { sx: {
                            zIndex: 1000,
                            with: "100%",
                        }, value: videoCurrentTime, max: video.duration, step: 0.001, onChange: function (_, value) {
                            try {
                                video.currentTime = value;
                            }
                            catch (_a) { }
                        } })] })), _jsxs(Grid, __assign({ item: true, container: true, xs: 12, alignItems: "center", justifyContent: "center" }, { children: [_jsx(VTButton, __assign({ sx: { marginRight: "5px", display: { xs: "none", sm: "inherit" } }, type: "icon", onClick: function () {
                            try {
                                video.currentTime = videoCurrentTime - 5;
                            }
                            catch (_a) { }
                        }, disabled: videoCurrentTime <= 5 && true }, { children: _jsx(FastRewindRounded, {}) })), videoCurrentState === "Playing" ? (_jsx(VTButton, __assign({ sx: { marginRight: "5px" }, type: "icon", onClick: function () {
                            try {
                                video.pause();
                                setVideoCurrentState("Paused");
                            }
                            catch (_a) { }
                        } }, { children: _jsx(PauseRounded, {}) }))) : (_jsx(VTButton, __assign({ sx: { marginRight: "5px" }, type: "icon", onClick: function () {
                            try {
                                video.play();
                                setVideoCurrentState("Playing");
                            }
                            catch (_a) { }
                        } }, { children: _jsx(PlayArrowRounded, {}) }))), _jsx(VTButton, __assign({ sx: { marginRight: "27px", display: { xs: "none", sm: "inherit" } }, type: "icon", onClick: function () {
                            try {
                                video.currentTime = videoCurrentTime + 5;
                            }
                            catch (_a) { }
                        }, disabled: video.duration - videoCurrentTime <= 5 && true }, { children: _jsx(FastForwardRounded, {}) })), currentTimeEditing ? (_jsx(_Fragment, { children: _jsxs("form", __assign({ onSubmit: function () {
                                video.pause();
                                video.currentTime = currentTimeEditInput;
                                setVideoCurrentState("Paused");
                                setCurrentTimeEditing(false);
                            } }, { children: [_jsx(VTTextField, { sx: {
                                        marginLeft: "10px",
                                        marginTop: "5px",
                                        height: "33px",
                                        width: "130px",
                                        borderRadius: "15px",
                                    }, autoFocus: true, type: "number", value: currentTimeEditInput.toString(), onChange: function (e) {
                                        setCurrentTimeEditInput(e.target.value);
                                    } }), _jsx(CancelRounded, { sx: {
                                        marginTop: "10px",
                                    }, color: "error", onClick: function () {
                                        setCurrentTimeEditInput(videoCurrentTime);
                                        setCurrentTimeEditing(false);
                                    } }), _jsx(SaveRounded, { sx: {
                                        marginTop: "10px",
                                    }, color: "success", type: "submit", onClick: function () {
                                        video.pause();
                                        video.currentTime = currentTimeEditInput;
                                    } })] })) })) : (_jsx(Box, __assign({ component: "div", sx: {
                            fontFamily: "Digit",
                            fontSize: "0.9em",
                            marginLeft: { xs: "20px", sm: "0px" },
                        }, onClick: function () {
                            // video.pause();
                            // setVideoCurrentState("Paused");
                            // setCurrentTimeEditInput(videoCurrentTime);
                            // setCurrentTimeEditing(true);
                        } }, { children: getTimeElapsedInStopWatchFormatString(videoCurrentTime * 1000) }))), _jsxs(Box, __assign({ component: "div", sx: {
                            fontFamily: "Digit",
                            fontSize: "0.9em",
                            marginLeft: "5px",
                            display: { xs: "none", sm: "inherit" },
                        } }, { children: ["/ ", video.duration ? getTimeElapsedInStopWatchFormatString(video.duration * 1000) : "00:00:00"] })), video && currentlyMuted ? (_jsx(VTButton, __assign({ onClick: function () {
                            video.muted = false;
                            localStorage.setItem("video_muted", "false");
                            setCurrentMuted(false);
                        }, sx: { marginLeft: "15px", display: { xs: "none", sm: "inherit" } }, type: "icon" }, { children: _jsx(VolumeOffRounded, {}) }))) : (_jsx(VTButton, __assign({ onClick: function () {
                            video.muted = true;
                            localStorage.setItem("video_muted", "true");
                            setCurrentMuted(true);
                        }, sx: { marginLeft: "15px", display: { xs: "none", sm: "inherit" } }, type: "icon" }, { children: _jsx(VolumeUpRounded, {}) })))] }))] })));
}
